import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const BonusesPendingReviewReport = Suspendable(
  lazy(() =>
    import('@modules/bonusesPendingReviewReport/controller/BonusesPendingReviewReportController').then(
      (module) => ({
        default: module.BonusesPendingReviewReportController,
      })
    )
  )
);

const BonusesPendingReviewDetails = Suspendable(
  lazy(() =>
    import('@modules/bonusesPendingReviewReport/submodules/bonusesPendingReviewDetails/controller/BonusesPendingReviewDetailsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const BonusesPendingReviewRoutes: RouteObject[] = [
  {
    element: <BonusesPendingReviewReport />,
    path: ROUTES.BONUSES_PENDING_REVIEW_REPORT.ROOT,
  },
  {
    element: <BonusesPendingReviewDetails />,
    path: ROUTES.BONUSES_PENDING_REVIEW_REPORT.DETAILS,
  },
];
